import { toAction } from 'rf-lib';
import { groups, transactions as transactionsAPI, games as gamesAPI } from '../../../api';
import * as t from './constants';

export const getGroupDetails = dispatch =>
  groupId => {
    dispatch(toAction(t.FETCH_GROUP_DETAILS));

    return groups.fetchGroupDetails(groupId)
      .then(groupsData => {
        if (!groupsData.groupName) {
          dispatch(toAction(t.FETCH_GROUP_DETAILS_FAILURE, { message: `Gruppen med id ${groupId} finnes ikke!` }));
        } else {
          dispatch(toAction(t.FETCH_GROUP_DETAILS_SUCCESS, groupsData));
        }
      })
      .catch(err => dispatch(toAction(t.FETCH_GROUP_DETAILS_FAILURE, err)));
  };

export const fetchGroupBalance = dispatch =>
  groupId => {
    dispatch(toAction(t.FETCH_GROUP_BALANCE));

    return transactionsAPI.fetchGroupTransactions(groupId)
      .then(groupsData => dispatch(toAction(t.FETCH_GROUP_BALANCE_SUCCESS,
        transactionsAPI.calculateGroupBalance(groupsData)
      )))
      .catch(err => dispatch(toAction(t.FETCH_GROUP_BALANCE_FAILURE, err)));
  };

export const fetchAllGameRunners = dispatch =>
  () => {
    dispatch(toAction(t.FETCH_ALL_GAMERUNNERS));

    return gamesAPI.fetchAllGameRunners()
      .then(gamesData => dispatch(toAction(t.FETCH_ALL_GAMERUNNERS_SUCCESS, gamesData)))
      .catch(err => dispatch(toAction(t.FETCH_ALL_GAMERUNNERS_FAILURE, err)));
  };

